import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ClapImg from "static/svg/clap.svg";
import dynamic from "next/dynamic";
import { useContext, useEffect } from "react";
import { trackEvent } from "services/bigbrain-service";
import { PRICING_PAGE_PURCHASE_NOW_REDIRECT, PRICING_PAGE_PURCHASE_NOW_REDIRECT_FAILURE } from "constants/bigbrain-event-types";
import { GenericConfigContext } from "contexts/generic-config-context";
import ProgressBarIntervalComponent from "../progress-bar-interval-component/progress-bar-interval-component";
import { StyledPurchaseNowModal } from "./purchase-now-modal.scss";
const DialogContentContainer = dynamic(()=>import("monday-ui-react-core/dist/DialogContentContainer"), {
    ssr: false
});
const PURCHASE_NOW_REDIRECT_SECONDS = 7;
const PurchaseNowModal = ({ isOpen, signupButton })=>{
    const { translate } = useContext(GenericConfigContext);
    useEffect(()=>{
        if (isOpen) {
            setTimeout(redirectToSingUp.bind(this, signupButton), PURCHASE_NOW_REDIRECT_SECONDS * 1000);
        }
    }, [
        isOpen
    ]);
    const redirectToSingUp = ()=>{
        if ((signupButton === null || signupButton === void 0 ? void 0 : signupButton.type) === "button") {
            trackEvent(PRICING_PAGE_PURCHASE_NOW_REDIRECT);
            signupButton.click();
        } else {
            trackEvent(PRICING_PAGE_PURCHASE_NOW_REDIRECT_FAILURE);
        }
    };
    if (!isOpen) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsxs(StyledPurchaseNowModal, {
        className: "purchase-dialog-wrapper",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "overlay"
            }),
            /*#__PURE__*/ _jsxs(DialogContentContainer, {
                type: "modal",
                className: "purchase-now-dialog",
                children: [
                    /*#__PURE__*/ _jsx(ClapImg, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: translate("pricingPage.purchaseNow.modal.title")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "subtitle",
                        dangerouslySetInnerHTML: {
                            __html: translate("pricingPage.purchaseNow.modal.subtitle")
                        }
                    }),
                    /*#__PURE__*/ _jsx(ProgressBarIntervalComponent, {
                        maxValue: PURCHASE_NOW_REDIRECT_SECONDS,
                        className: "progress-bar"
                    })
                ]
            })
        ]
    });
};
export default PurchaseNowModal;
